export default __webpack_public_path__ + "static/media/megaphone.0957e8d1.png";